<template>
  <section
    id="page-header"
    class="mt-2 mb-12"
  >
    <h1
      class="text-h4 mb-2"
      v-text="header"
    />
    <div id="IC_D_728x90_3" />
    <div id="IC_M_320x50_3" />
    <h2
      v-if="text"
      class="text-subtitle-1"
      v-html="text"
    />
  </section>
</template>

<script>
export default {
  props: {
    header: {
      type: String,
      required: true
    },
    text: {
      type: String
    }
  }
}
</script>

<style lang="scss">
#page-header {
  max-width: 1185px;
}
</style>
